import { formatCurrency as formatCurrencyShared } from '../../../utils/formatUtils';

const DOCUMENT_TYPE_LABELS = {
  80: 'CUIT',
  86: 'CUIL',
  87: 'CDI',
  89: 'LE',
  90: 'LC',
  91: 'CI',
  96: 'DNI',
  99: 'Consumidor Final',
};

const CONCEPT_LABELS = {
  1: 'Productos',
  2: 'Servicios',
  3: 'Productos y Servicios',
};

export const formatAfipDate = (dateStr) => {
  if (!dateStr || dateStr.length !== 8) return '';
  const yyyy = dateStr.slice(0, 4);
  const mm = dateStr.slice(4, 6);
  const dd = dateStr.slice(6, 8);
  return `${dd}/${mm}/${yyyy}`;
};

export const formatCurrency = (value) => formatCurrencyShared(value, { fallback: '-' });

export const getDocumentTypeLabel = (docType) => {
  if (docType == null) return '';
  return DOCUMENT_TYPE_LABELS[docType] || `Tipo ${docType}`;
};

export const formatDocument = (documentType, documentNumber) => {
  if (!documentNumber) return '';
  const typeLabel = getDocumentTypeLabel(documentType);
  return typeLabel ? `${typeLabel} ${documentNumber}` : documentNumber;
};

export const formatVoucherIdentifier = (salePoint, voucherNumber) => {
  if (salePoint == null || voucherNumber == null) return '';
  const salePointPadded = String(salePoint).padStart(4, '0');
  const voucherPadded = String(voucherNumber).padStart(8, '0');
  return `${salePointPadded}-${voucherPadded}`;
};

export const getConceptLabel = (conceptCode) => {
  if (conceptCode == null) return '';
  return CONCEPT_LABELS[conceptCode] || `Concepto ${conceptCode}`;
};

export const formatCurrencyRate = (rate) => {
  if (rate == null || Number.isNaN(Number(rate))) return '-';
  return Number(rate).toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  });
};
